import { graphql } from "api/cms-website/generated";

import { ResponsiveImageFragment } from "../primitives/responsiveImage";

export const VideoFragment = graphql(/* GraphQL */ `
    fragment VideoFragment on ComponentComponentsVideo {
        id
        noMarginBottom
        videoTitle: title
        videoText: text
        videoCaption: caption
        videoUrl
        videoUrlMobile
        poster {
            ...ResponsiveImageFragment
        }
    }
    ${ResponsiveImageFragment}
`);
